import { F as FileSaver_minExports } from '../../../_virtual/FileSaver.min.js';

const FileUtils = {
  export(filename, textContent) {
    const blob = new Blob([textContent], { type: "text/plain;charset=utf-8" });
    FileSaver_minExports.saveAs(blob, filename);
  }
};

export { FileUtils };
//# sourceMappingURL=file-utils.js.map
